export interface CreatePortfolioRequest {
  reference?: string
  earningProductId: string
}

export interface PortfolioTransportRequest {
  reference: string
  portfolioId: string
  counterparty: PortfolioTransportCounterparty
}

interface PortfolioTransportCounterparty {
  walletId: string
  amount: string
}

export interface Balance {
  total: string
  blocked: string
  available: string
  totalInBaseCurrency: string
}

export const PortfolioStatus = {
  CREATED: 'CREATED',
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED',
} as const

export type PortfolioStatus = (typeof PortfolioStatus)[keyof typeof PortfolioStatus]

export interface Portfolio {
  id: string
  object: 'portfolio'
  reference?: string | null
  walletId?: string | null
  currency: string
  status: PortfolioStatus
  balance: Balance
  totalEarnedAmount: string
  createdAt: string
  updatedAt: string
}

export interface PortfolioTransportResponse {
  id: string
  object: string
  reference: string
  status: string
  direction: string
  portfolioId?: string
  amount?: string
  currency?: string
  counterpartyWalletId: string
  createdAt: string
  updatedAt: string
}

export interface GetPortfoliosResponse {
  content: Portfolio[]
  totalPages: number
  totalElements: number
  size: number
  number: number
  pageable: PortfolioPageable
}

export interface PortfolioPageable {
  pageNumber: number
  pageSize: number
  sort: string[]
  offset: number
}

export interface RewardsProduct {
  id: string
  object: string
  currency: string
  earningRate: number
}

export interface GetRewardsProductsResponse {
  content: RewardsProduct[]
  totalElements: number
  pageable?: {
    pageNumber: number
    pageSize: number
  }
}

export interface GetRewardsProductsParams {
  pageNumber?: number
  pageSize?: number
  currency?: string
}

export interface TransactionAmount {
  value: number
  currencyCode: string
}

export interface TransactionEntity {
  type: string
  name: string
}

export interface TransactionParty {
  entity: TransactionEntity
  amount: TransactionAmount
}

export interface GetPortfoliosParams {
  pageNumber?: number
  pageSize?: number
}

export interface CustomerEarningsSummaryParams {
  currency: string
}

export interface CustomerEarningsSummaryResponse {
  totalPrincipalBalance: string
  totalUnpaidEarnings: string
  totalEarnedAmount: string
  currency: string
  object: 'customer_earnings_summary'
}

export interface MonthlyCustomersEarnings {
  id: string
  object: 'monthlyCustomersEarnings'
  amount: string
  currency: string
  earningsPeriodEnd: string
  createdAt: string
  updatedAt: string
}

export interface PageInfo {
  number: number
  size: number
  totalElements: number
  totalPages: number
}

export interface GetMonthlyCustomersEarningsResponse {
  content: MonthlyCustomersEarnings[]
  page: PageInfo
}

export interface GetMonthlyCustomersEarningsParams {
  currency: string
  startDate?: string
  endDate?: string
  pageNumber?: number
  pageSize?: number
}

export interface UpdateEarningsDistributionRequest {
  currency: string
  automatic: true
  destinationWalletId: string
}

export interface CustomersEarningsWithdrawalRequest {
  destinationWalletId: string
}
